import { AdminApp, AuthApp, DerivativesApp, MemberApp } from "apps";

export default () => {
	const apps = [AuthApp, MemberApp, DerivativesApp, AdminApp];

	return {
		apps
	};
};
